import { render } from "./drawer-employee-detail.vue?vue&type=template&id=4a0207ae&scoped=true&ts=true"
import script from "./drawer-employee-detail.vue?vue&type=script&lang=ts"
export * from "./drawer-employee-detail.vue?vue&type=script&lang=ts"

import "./drawer-employee-detail.vue?vue&type=style&index=0&id=4a0207ae&lang=stylus&scoped=true"

import exportComponent from "E:\\code\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a0207ae"]])

export default __exports__